import PnlModalCardPreview from 'src/components/Modals/PnlModal/PnlModalCardPreview';
import PnlModalPaginationDisplay from 'src/components/Modals/PnlModal/PnlModalPaginationDisplay';
import PnlModalOptions from 'src/components/Modals/PnlModal/PnlModalOptions';
import PnlModalButtons from 'src/components/Modals/PnlModal/PnlModalButtons/PnlModalButtons';
import PnlModalPaginationControls from 'src/components/Modals/PnlModal/PnlModalPaginationControls';
import { PnlModalCardPreviewVariantProps } from 'src/components/Modals/PnlModal/types';
import BottomDrawer from 'src/components/Drawers/BaseDrawers/BottomDrawer/BottomDrawer';
import Divider from 'src/components/primitives/Divider/Divider';
import { cj } from 'src/utils/classNames';

interface Props {
	backgroundImagePathIndex: number;
	setBackgroundImagePathIndex: (index: number) => void;
	showCollateral: boolean;
	setShowCollateral: (showCollateral: boolean) => void;
	imageGenerationNodeRef: React.RefObject<HTMLDivElement | null>;
	handleCloseMobileDrawer: () => void;
	isMobileDrawerClosing: boolean;
	handleDownload: () => void;
	isDownloading: boolean;
	handleCopy: () => void;
	isCopying: boolean;
	isCopied: boolean;
	cardPreviewVariantProps: PnlModalCardPreviewVariantProps;
}

export default function PnlModalMobile({
	backgroundImagePathIndex,
	setBackgroundImagePathIndex,
	showCollateral,
	setShowCollateral,
	imageGenerationNodeRef,
	handleCloseMobileDrawer,
	isMobileDrawerClosing,
	handleDownload,
	handleCopy,
	isDownloading,
	isCopying,
	isCopied,
	cardPreviewVariantProps,
}: Props) {
	const { variant, positionData } = cardPreviewVariantProps;
	const isFromPositionHistory =
		positionData?.triggeredFrom === 'position_history_table';
	const shouldShowCollateral = showCollateral && !isFromPositionHistory;

	return (
		<>
			{/* On mobile, the PnL card is displayed separate from the bottom drawer, "floating" around the middle of the screen. */}
			<div
				// Manual overlay and container for the floating PnL card.
				className="fixed inset-0 grid place-items-center bg-overlay"
				onClick={handleCloseMobileDrawer}
			>
				<div
					className={cj(
						'w-[calc(100%-16px)] max-w-[350px] overflow-hidden rounded-sm',
						variant === 'portfolio-performance'
							? '-translate-y-1/4'
							: '-translate-y-1/2'
					)}
				>
					<PnlModalCardPreview
						backgroundImagePathIndex={backgroundImagePathIndex}
						showCollateral={shouldShowCollateral}
						imageGenerationNodeRef={imageGenerationNodeRef}
						cardPreviewVariantProps={cardPreviewVariantProps}
					/>
				</div>
				<PnlModalPaginationControls
					className="translate-y-full"
					xOffset={8}
					backgroundImagePathIndex={backgroundImagePathIndex}
					setBackgroundImagePathIndex={setBackgroundImagePathIndex}
					marketIndex={positionData?.position.marketIndex}
					variant={variant}
				/>
			</div>
			<BottomDrawer.Container
				className="w-full text-text-default"
				closeDrawer={handleCloseMobileDrawer}
				isDrawerClosing={isMobileDrawerClosing}
				disableOverlay
			>
				<BottomDrawer.Title
					innerWrapperClassName="border-none"
					closeDrawer={handleCloseMobileDrawer}
					endElement={
						<PnlModalPaginationDisplay
							backgroundImagePathIndex={backgroundImagePathIndex}
							marketIndex={positionData?.position.marketIndex}
							variant={variant}
						/>
					}
				>
					Share P&L
				</BottomDrawer.Title>
				<BottomDrawer.Body className="pt-0">
					<Divider />

					{variant !== 'portfolio-performance' && !isFromPositionHistory && (
						<PnlModalOptions
							className="flex-col gap-y-lg"
							showCollateral={showCollateral}
							setShowCollateral={setShowCollateral}
							triggeredFromPositionClose={
								positionData?.triggeredFrom === 'position_closed'
							}
						/>
					)}

					<PnlModalButtons
						handleClose={handleCloseMobileDrawer}
						handleDownload={handleDownload}
						handleCopy={handleCopy}
						isDownloading={isDownloading}
						isCopying={isCopying}
						isCopied={isCopied}
					/>
				</BottomDrawer.Body>
			</BottomDrawer.Container>
		</>
	);
}
